import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Tag,
  notification,
  Spin,
  Modal,
  Progress,
  Pagination,
  Radio,
  Empty,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllUser } from "../../Graphs/User/listUser";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  LockOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  BookOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import AssignCourseModal from "./AssignCourseModal";
import { deleteUser } from "../../Graphs/User/deleteUser";
import { changeStatus } from "../../Graphs/User/changeStatus";
import { editUser } from "../../Graphs/User/editUser";
import { editCorporateUser } from "../../Graphs/User/EditCorporateUser";
import { searchUser } from "../../Graphs/User/searchUser";
import { changePassword } from "../../Graphs/User/changePassword";
import EditModal from "./EditModal";
import { ChangePassowordModal } from "./ChangePassowordModal";
import * as moment from "moment";
import { checkPermission } from "../AdminUser/CheckPremission";
import ListModel from "./ListModel";

const BASE_IMAGE_URL =
  "https://s3.us-east-2.amazonaws.com/cerebrus-consulting/bloodman_user_media/";

const NativeSelect = ({ value, onChange, children, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={className}
      style={{
        padding: "3px 8px",
        borderRadius: "4px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        outline: "none",
        cursor: "pointer",
        marginLeft: "8px",
        height: "28px"
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) return null;
        return <option value={child.props.value}>{child.props.children}</option>;
      })}
    </select>
  );
};

class UserRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
      showCoursesModal: false,
      selectedUserForAssign: null,
      showAssignCourseModal: false,
      viewType: "table",
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedUser = this.getLimitedUser.bind(this);
  }

  async componentDidMount() {
    this.setState({
      isLoading: false,
    });
  }

  modalRef;
  changePasswordmodalRef;
  showCoursesListModalRef;

  async getLimitedUser(pagination) {
    const page = pagination.current || 1;
    const pageSize = pagination.pageSize || 10;
    const skip = (page - 1) * pageSize;
    if (this.props.searchText) {
      this.setState({
        pagination: {
          ...this.state.pagination,
          current: page,
          pageSize: pageSize,
        },
      });
      return;
    }
    await this.listUserData(skip, pageSize);
  }

  listSearchUserData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserData,
        setListUserDataTotal,
        searchText,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let userData = await searchUser(
        authToken,
        searchText,
        0,
        1000000,
        "Teacher"
      );

      if (userData.status === 200) {
        //set user Data
        await setListUserData(userData.data);
        // await setListUserData(userData.data.docs);
        await setListUserDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
          // data: userData.data.docs,
        });
      } else if (userData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  listUserData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserData,
        setListUserDataTotal,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      const skip = typeof start === "number" ? start : 0;
      const limit = typeof end === "number" ? end : (this.state.pagination.pageSize || 10);

      let userData = await getAllUser(authToken, skip, limit);

      if (userData.status === 200) {
        //set user Data
        await setListUserData(userData.data);
        await setListUserDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
          pagination: {
            ...this.state.pagination,
            current: Math.floor(skip / limit) + 1,
            pageSize: limit,
          },
        });
      } else if (userData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  dateFormat(date) {
    var oldDate = new Date(date),
      momentObj = moment(oldDate).utc(),
      newDate = momentObj.format("YYYY-MM-DD");

    return newDate;
  }

  showModal(item, loginUserData) {
    // console.log("open modal", item);

    // console.log("Model Ref: ", this.props)
    this.setState(
      {
        userSelectedData: item,
        // isOpen: true
      },
      () => {
        this.modalRef.show();
      }
    );
  }

  showChangePasswordModal(item) {
    // console.log("open modal", item);
    // console.log("PAssWord: ", this.changePasswordmodalRef)
    this.setState(
      {
        userSelectedData: item,
        // isOpen: true
      },
      () => {
        this.changePasswordmodalRef.show();
      }
    );
  }
  showCoursesListModal(item) {
    console.log("ABC: ", item);
    localStorage.setItem("view_user_details", JSON.stringify(item));
  }

  handleModalclose() {
    this.setState({
      userSelectedData: null,
    });
  }

  formatDuration(seconds) {
    seconds = Math.floor(seconds);

    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hrs > 0) parts.push(`${hrs} hour${hrs !== 1 ? "s" : ""}`);
    if (mins > 0) parts.push(`${mins} minute${mins !== 1 ? "s" : ""}`);
    if (secs > 0 || parts.length === 0)
      parts.push(`${secs} second${secs !== 1 ? "s" : ""}`);

    return parts.join(" ");
  }

  getColumns = () => {
    const { loginUserData } = this.props;
    const isCorporate = loginUserData && loginUserData.role === "corporate";

    if (isCorporate) {
      return this.columns.filter(
        (col) => col.key !== "is_active" && col.key !== "category" && col.key !== "site"
      );
    }

    return this.columns;
  };

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        const { current, pageSize } = this.state.pagination;
        const serialNumber = (current - 1) * pageSize + index + 1;
        return (
          <span style={{ fontWeight: 500, color: "#8c8c8c" }}>{serialNumber}</span>
        );
      },
    },
    {
      title: "Name",
      key: "username",
      render: (text, item) => {
        const fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim() || item.username || "N/A";
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Avatar
              icon={<UserOutlined />}
              src={item.profile_image_url}
              style={{ backgroundColor: `${this.props.primaryColor || '#5C6AC4'}15`, color: this.props.primaryColor || '#5C6AC4' }}
            />
            <span style={{ fontWeight: 600, color: "#262626" }}>{fullName}</span>
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "email",
      render: (text, item) => (
        <span style={{ color: "#595959" }}>{item.email || "-"}</span>
      ),
    },
    {
      title: "Category",
      key: "category",
      render: (text, item) => (
        <span style={{ fontWeight: 500, color: "#595959" }}>{item.category || "-"}</span>
      ),
    },
    {
      title: "Site",
      key: "site",
      render: (text, item) => (
        <span style={{ fontWeight: 500, color: "#595959" }}>{item.site || "-"}</span>
      ),
    },
    {
      title: "Progress",
      key: "progress",
      render: (text, item) => {
        const progress = Math.min(100, Math.max(0, item.averageProgress || 0));
        const color = this.props.primaryColor || "#3b82f6";
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "130px" }}>
            <div style={{ flex: 1, height: "8px", backgroundColor: "#f0f0f0", borderRadius: "4px", overflow: "hidden" }}>
              <div
                style={{
                  height: "100%",
                  width: `${progress}%`,
                  backgroundColor: color,
                  borderRadius: "4px",
                  transition: "width 0.3s ease",
                }}
              />
            </div>
            <span style={{ fontSize: "12px", fontWeight: 600, color: "#595959", minWidth: "40px" }}>
              {progress.toFixed(0)}%
            </span>
          </div>
        );
      },
    },
    {
      title: "Learning Hours",
      key: "totalduration",
      render: (text, item) => {
        const durationInSeconds = item.totalDuration;
        const displayDuration = durationInSeconds ? this.formatDuration(durationInSeconds) : "-";
        return (
          <span style={{ fontWeight: 500, color: "#262626" }}>{displayDuration}</span>
        );
      },
    },
    {
      title: "Last Visit",
      key: "accessed_date",
      render: (text, item) => {
        const date = item.last_visit_course ? item.last_visit_course.last_visit_date : undefined;
        if (!date) return <span style={{ color: "#bfbfbf" }}>-</span>;
        const relativeTime = moment(date).fromNow();
        return (
          <Tag style={{ borderRadius: "10px", fontSize: "12px", border: "none", backgroundColor: "#f5f5f5", color: "#595959" }}>
            {relativeTime}
          </Tag>
        );
      },
    },
    {
      title: "isActive",
      key: "is_active",
      render: (text, item) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "user", "edit");
        return (
          <div>
            {item.is_active != null ? (
              <Switch
                checked={item.is_active}
                style={{
                  backgroundColor: item.is_active
                    ? this.props.primaryColor || "#5C6AC4"
                    : "#bababa",
                }}
                onChange={this.onChange.bind(this, item)}
                disabled={!canEdit}
              />
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      width: 180,
      render: (text, item) => {
        const { loginUserData, primaryColor } = this.props;
        const canEdit = checkPermission(loginUserData, "user", "edit");
        const canDelete = checkPermission(loginUserData, "user", "delete");

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {canEdit && (
              <Tooltip title="Edit">
                <Button
                  shape="circle"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => this.showModal(item, loginUserData)}
                />
              </Tooltip>
            )}
            {canEdit && (
              <Tooltip title="Change Password">
                <Button
                  shape="circle"
                  size="small"
                  icon={<LockOutlined />}
                  onClick={() => this.showChangePasswordModal(item)}
                />
              </Tooltip>
            )}
            {canDelete && (
              <Tooltip title="Delete">
                <Popconfirm
                  onConfirm={this.deleteUserData.bind(this, item)}
                  title="Are you sure you want to delete User?"
                  placement="topRight"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  <Button shape="circle" size="small" icon={<DeleteOutlined style={{ color: "#ff4d4f" }} />} />
                </Popconfirm>
              </Tooltip>
            )}
            <Link to={`user/detail/${item._id}`}>
              <Tooltip title="View User Details">
                <Button
                  shape="circle"
                  size="small"
                  icon={<EyeOutlined style={{ color: primaryColor || "#5C6AC4" }} />}
                  onClick={() => this.showCoursesListModal(item)}
                />
              </Tooltip>
            </Link>
            {canEdit && loginUserData &&
              (loginUserData.role === "corporate" ||
               (loginUserData.role && loginUserData.role.toLowerCase().includes("admin"))) && (
                <Tooltip title="Assign Course">
                  <Button
                    shape="circle"
                    size="small"
                    icon={<BookOutlined style={{ color: primaryColor || "#4466f2" }} />}
                    onClick={() => {
                      this.setState({
                        selectedUserForAssign: item,
                        showAssignCourseModal: true,
                      });
                    }}
                  />
                </Tooltip>
              )}
          </div>
        );
      },
    },
  ];

  async deleteUserData(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListUserData,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteUser(authToken, item._id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete User",
          description: "Successfully deleted",
        });

        await this.listUserData(0, 10);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete Category",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async onChange(item, checked) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item._id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change User Status",
          description: "Successfully changed status",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchUserData(startIndex, limitNumber);
          return;
        }
        this.listUserData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      notification["error"]({
        message: "Change User Status",
        description: err,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  editSubmit = async (userObject, userId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
        loginUserData,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      // console.log(loginUserData)

      this.setState({
        isLoading: true,
      });

      let statusData;

      if (loginUserData.role === "corporate") {
        statusData = await editCorporateUser(authToken, userObject, userId);
      } else {
        statusData = await editUser(authToken, userObject, userId);
      }
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit User Status",
          description: "Successfully edited",
        });
        {
          /*
          if (searchText != null && searchText !== "") {
            this.listSearchCategoryData(startIndex, limitNumber);
            return;
          }*/
        }
        this.handleModalclose();
        this.listUserData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Category",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleChangePassword = async (adminObject, adminId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changePassword(authToken, adminObject, adminId);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Admin Status",
          description: "Successfully edited",
        });

        this.listAdminData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Admin",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTableChange(pagination, filters) {
    console.log("Pagination Changed: ", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedUser(pagination)
    );
  }

  render() {
    const { isLoading, data } = this.state;
    const {
      userList,
      userTotal,
      listUserData,
      searchLoader,
      loginUserData,
      statusFilter,
      dateRangeFilter,
      userCategoryFilter,
      userSiteFilter,
      userProgressFilter,
      searchText,
    } = this.props;

    let filteredUserData = listUserData || [];

    // Client-side search filter
    if (searchText && searchText.trim() !== "") {
      const query = searchText.toLowerCase().trim();
      filteredUserData = filteredUserData.filter(user => {
        const firstName = (user.first_name || "").toLowerCase();
        const lastName = (user.last_name || "").toLowerCase();
        const email = (user.email || "").toLowerCase();
        const category = (user.category || "").toLowerCase();
        const site = (user.site || "").toLowerCase();
        return firstName.includes(query) || lastName.includes(query) || email.includes(query) || category.includes(query) || site.includes(query);
      });
    }

    // Filter by Active / Inactive status
    if (statusFilter === "active") {
      filteredUserData = filteredUserData.filter(user => user.is_active);
    } else if (statusFilter === "inactive") {
      filteredUserData = filteredUserData.filter(user => !user.is_active);
    }

    // Filter by Last Visited Date Range
    if (dateRangeFilter && dateRangeFilter.length === 2 && dateRangeFilter[0] && dateRangeFilter[1]) {
      const startDate = moment(dateRangeFilter[0]).startOf("day");
      const endDate = moment(dateRangeFilter[1]).endOf("day");
      filteredUserData = filteredUserData.filter(user => {
        const visitDate = user.last_visit_course ? user.last_visit_course.last_visit_date : null;
        if (!visitDate) return false;
        const mVisitDate = moment(visitDate);
        return mVisitDate.isBetween(startDate, endDate, null, "[]");
      });
    }

    // Filter by Category
    if (userCategoryFilter && userCategoryFilter !== "all") {
      filteredUserData = filteredUserData.filter(user => {
        return (user.category || "").trim() === userCategoryFilter.trim();
      });
    }

    // Filter by Site
    if (userSiteFilter && userSiteFilter !== "all") {
      filteredUserData = filteredUserData.filter(user => {
        return (user.site || "").trim() === userSiteFilter.trim();
      });
    }

    // Filter by Progress Wise
    if (userProgressFilter && userProgressFilter !== "all") {
      filteredUserData = filteredUserData.filter(user => {
        const progress = user.averageProgress || 0;
        if (userProgressFilter === "notStarted") {
          return progress === 0;
        } else if (userProgressFilter === "inProgress") {
          return progress > 0 && progress < 100;
        } else if (userProgressFilter === "completed") {
          return progress === 100;
        }
        return true;
      });
    }

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div>
        {/* View Toggle */}
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
          paddingRight: "15px"
        }}>
          <style>{`
            .theme-radio-group .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
              background-color: ${this.props.primaryColor || '#1890ff'} !important;
              border-color: ${this.props.primaryColor || '#1890ff'} !important;
              color: #fff !important;
            }
            .theme-radio-group .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
              background-color: ${this.props.primaryColor || '#1890ff'} !important;
              border-color: ${this.props.primaryColor || '#1890ff'} !important;
              color: #fff !important;
            }
            .theme-radio-group .ant-radio-button-wrapper:hover {
              color: ${this.props.primaryColor || '#1890ff'} !important;
            }
            .theme-radio-group .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
              background-color: ${this.props.primaryColor || '#1890ff'} !important;
            }
            .theme-radio-group .ant-radio-button-wrapper:focus-within {
              outline: none;
            }
            .theme-radio-group .ant-radio-button-wrapper-checked:focus-within {
              box-shadow: 0 0 0 3px ${(this.props.primaryColor || '#1890ff')}20 !important;
            }
          `}</style>
          <Radio.Group
            value={this.state.viewType}
            onChange={(e) => this.setState({ viewType: e.target.value })}
            buttonStyle="solid"
            className="theme-radio-group"
          >
            <Radio.Button value="card">
              <AppstoreOutlined style={{ marginRight: "6px" }} /> Card View
            </Radio.Button>
            <Radio.Button value="table">
              <UnorderedListOutlined style={{ marginRight: "6px" }} /> Table View
            </Radio.Button>
          </Radio.Group>
        </div>

        {(() => {
          const totalUserCount = this.props.listUserDataTotal || userTotal || filteredUserData.length;
          const isClientPaginated = filteredUserData.length > this.state.pagination.pageSize || !!searchText;
          const cardsToDisplay = isClientPaginated
            ? filteredUserData.slice(
                (this.state.pagination.current - 1) * this.state.pagination.pageSize,
                this.state.pagination.current * this.state.pagination.pageSize
              )
            : filteredUserData;

          return this.state.viewType === "card" ? (
            <div>
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: "20px",
                padding: "10px"
              }}>
                {cardsToDisplay && cardsToDisplay.length > 0 ? (
                  cardsToDisplay.map((item, index) => {
                const canEdit = checkPermission(loginUserData, "user", "edit");
                const canDelete = checkPermission(loginUserData, "user", "delete");
                const progress = item.averageProgress || 0;
                const durationInSeconds = item.totalDuration;
                const displayDuration = durationInSeconds ? this.formatDuration(durationInSeconds) : "-";
                const lastVisitDate = item.last_visit_course ? item.last_visit_course.last_visit_date : undefined;
                const relativeTime = lastVisitDate ? moment(lastVisitDate).fromNow() : "-";

                // Generate initials for avatar placeholder
                const initials = ((item.first_name || "").substring(0, 1) + (item.last_name || "").substring(0, 1)).toUpperCase() || "?";

                return (
                  <div key={item._id} style={{
                    background: "#fff",
                    borderRadius: "16px",
                    border: "1px solid #eef2f6",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition: "all 0.3s ease",
                    position: "relative"
                  }}>
                    {/* Top Row: User Avatar, Name & Switch */}
                    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", marginBottom: "14px" }}>
                      <Avatar style={{
                        background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                        verticalAlign: 'middle',
                      }} size={48}>
                        {initials}
                      </Avatar>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: "700", fontSize: "15px", color: "#262626", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                          {item.first_name} {item.last_name || ""}
                        </div>
                        <div style={{ fontSize: "12px", color: "#8c8c8c", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                          {item.email}
                        </div>
                      </div>
                      <div>
                        {item.is_active != null && loginUserData?.role !== "corporate" && (
                          <Switch
                            size="small"
                            checked={item.is_active}
                            style={{
                              backgroundColor: item.is_active
                                ? this.props.primaryColor
                                : "#bababa",
                            }}
                            onChange={this.onChange.bind(this, item)}
                            disabled={!canEdit}
                          />
                        )}
                      </div>
                    </div>

                    {/* Tags Section */}
                    {loginUserData?.role !== "corporate" && (item.category || item.site) && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "16px" }}>
                        {item.category && (
                          <Tag color="purple" style={{ borderRadius: "12px", fontSize: "11px", padding: "1px 8px" }}>
                            {item.category}
                          </Tag>
                        )}
                        {item.site && (
                          <Tag color="cyan" style={{ borderRadius: "12px", fontSize: "11px", padding: "1px 8px" }}>
                            {item.site}
                          </Tag>
                        )}
                      </div>
                    )}

                    {/* Progress Section */}
                    <div style={{ marginBottom: "16px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#8c8c8c", marginBottom: "4px" }}>
                        <span>Avg Progress</span>
                        <span style={{ fontWeight: "600", color: "#262626" }}>{progress.toFixed(1)}%</span>
                      </div>
                      <Progress
                        percent={Math.round(progress)}
                        size="small"
                        status="active"
                        strokeColor={this.props.primaryColor}
                      />
                    </div>

                    {/* Details Rows */}
                    <div style={{ borderTop: "1px dashed #eef2f6", paddingTop: "12px", marginBottom: "16px", display: "flex", flexDirection: "column", gap: "8px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                        <span style={{ color: "#8c8c8c" }}>Learning Time</span>
                        <span style={{ fontWeight: "600", color: "#262626" }}>{displayDuration}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
                        <span style={{ color: "#8c8c8c" }}>Last Visit</span>
                        <span style={{ fontWeight: "600", color: "#262626" }}>{relativeTime}</span>
                      </div>
                    </div>

                    {/* Bottom Actions Bar */}
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      background: "#f8fafc",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      marginTop: "auto"
                    }}>
                      {canEdit && (
                        <Tooltip title="Edit">
                          <Button
                            shape="circle"
                            size="middle"
                            icon={<EditOutlined />}
                            onClick={() => this.showModal(item, loginUserData)}
                          />
                        </Tooltip>
                      )}
                      {canEdit && (
                        <Tooltip title="Change Password">
                          <Button
                            shape="circle"
                            size="middle"
                            icon={<LockOutlined />}
                            onClick={() => this.showChangePasswordModal(item)}
                          />
                        </Tooltip>
                      )}
                      {canDelete && (
                        <Popconfirm
                          onConfirm={this.deleteUserData.bind(this, item)}
                          title="Are you sure you want to delete User?"
                        >
                          <Button shape="circle" size="middle" icon={<DeleteOutlined />} />
                        </Popconfirm>
                      )}
                      <Link to={{
                        pathname: `${process.env.PUBLIC_URL}/user/detail/${item._id}`,
                        state: { adminSelectedData: item }
                      }}>
                        <Tooltip title="View User Details">
                          <Button
                            shape="circle"
                            size="middle"
                            icon={<EyeOutlined />}
                            onClick={() => this.showCoursesListModal(item)}
                          />
                        </Tooltip>
                      </Link>
                      {canEdit && loginUserData &&
                        (loginUserData.role === "corporate" ||
                         (loginUserData.role && loginUserData.role.toLowerCase().includes("admin"))) && (
                          <Tooltip title="Assign Course">
                            <Button
                              shape="circle"
                              size="middle"
                              icon={<BookOutlined />}
                              style={{
                                color: this.props.primaryColor || "#4466f2",
                                borderColor: this.props.primaryColor || "#4466f2",
                              }}
                              onClick={() => {
                                this.setState({
                                  selectedUserForAssign: item,
                                  showAssignCourseModal: true,
                                });
                              }}
                            />
                          </Tooltip>
                        )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ gridColumn: "1 / -1", padding: "60px 0", textAlign: "center" }}>
                <Empty description="No Users Found" />
              </div>
            )}
          </div>

            {/* Card View Pagination */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", paddingRight: "10px" }}>
              <Pagination
                total={totalUserCount}
                showSizeChanger
                pageSize={this.state.pagination.pageSize}
                current={this.state.pagination.current}
                pageSizeOptions={["10", "25", "50", "100"]}
                selectComponentClass={NativeSelect}
                onChange={(page, pageSize) => {
                  this.setState(
                    {
                      pagination: {
                        ...this.state.pagination,
                        current: page,
                        pageSize: pageSize,
                      },
                    },
                    () => {
                      this.getLimitedUser({
                        current: page,
                        pageSize: pageSize,
                      });
                    }
                  );
                }}
                onShowSizeChange={(current, size) => {
                  this.setState(
                    {
                      pagination: {
                        ...this.state.pagination,
                        current: 1,
                        pageSize: size,
                      },
                    },
                    () => {
                      this.getLimitedUser({
                        current: 1,
                        pageSize: size,
                      });
                    }
                  );
                }}
              />
            </div>
          </div>
        ) : (
          <div style={{
            background: "#fff",
            borderRadius: "16px",
            border: "1px solid #eef2f6",
            boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
            padding: "20px",
            overflowX: "auto"
          }}>
            <Table
              loading={this.state.isLoading}
              rowKey={(record) => record._id}
              columns={this.getColumns()}
              size="small"
              dataSource={filteredUserData}
              pagination={{
                total: this.props.listUserDataTotal || userTotal || filteredUserData.length,
                showSizeChanger: true,
                pageSize: this.state.pagination.pageSize,
                current: this.state.pagination.current,
                pageSizeOptions: ["10", "25", "50", "100"],
                selectComponentClass: NativeSelect,
                onChange: (page, pageSize) => {
                  console.log("Page change:", page, "Page size:", pageSize);

                  this.setState(
                    {
                      pagination: {
                        ...this.state.pagination,
                        current: page,
                        pageSize: pageSize,
                      },
                    },
                    () => {
                      this.getLimitedUser({
                        current: page,
                        pageSize: pageSize,
                      });
                    }
                  );
                },
                onShowSizeChange: (current, size) => {
                  this.setState(
                    {
                      pagination: {
                        ...this.state.pagination,
                        current: 1, // Reset to first page when changing size
                        pageSize: size,
                      },
                    },
                    () => {
                      this.getLimitedUser({
                        current: 1,
                        pageSize: size,
                      });
                    }
                  );
                },
              }}
              onChange={this.handleTableChange}
            />
          </div>
        );
      })()}

        {/* {this.state.userSelectedData &&
        checkPermission(loginUserData.permissions, "user", "edit") ? ( */}
        <EditModal
          admin={false}
          refx={(e) => (this.modalRef = e)}
          onClose={this.handleModalclose.bind(this)}
          userSelectedData={this.state.userSelectedData}
          onSubmit={this.editSubmit}
        />
        {/* ) : null} */}

        <ChangePassowordModal
          admin={false}
          refx={(e) => (this.changePasswordmodalRef = e)}
          onClose={this.handleModalclose.bind(this)}
          adminSelectedData={this.state.userSelectedData}
          onChangePassword={this.handleChangePassword}
        />

        <AssignCourseModal
          visible={!!this.state.showAssignCourseModal}
          user={this.state.selectedUserForAssign}
          primaryColor={this.props.primaryColor}
          onSuccess={() => {
            const { startIndex, limitNumber } = this.state;
            this.listUserData(startIndex, limitNumber);
          }}
          onClose={() =>
            this.setState({
              showAssignCourseModal: false,
              selectedUserForAssign: null,
            })
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
  listUserData: state.user.listUserData,
  listUserDataTotal: state.user.listUserDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
  admin: state.admin,
  statusFilter: state.auth.statusFilter,
  dateRangeFilter: state.auth.dateRangeFilter,
  userCategoryFilter: state.auth.userCategoryFilter,
  userSiteFilter: state.auth.userSiteFilter,
  userProgressFilter: state.auth.userProgressFilter,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListUserData: (listUserData) => {
      dispatch({
        type: "SET_LIST_USER_DATA",
        listUserData: listUserData,
      });
    },
    setListUserDataTotal: (listUserDataTotal) => {
      dispatch({
        type: "SET_LIST_USER_DATA_TOTAL",
        listUserDataTotal: listUserDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserRecordsTable));
